import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration - matches iOS app project
const firebaseConfig = {
  apiKey: "AIzaSyCU8_XAaeplHdn3tDwJUnx-Q1P8qcs4BvM",
  authDomain: "check-in-b0aca.firebaseapp.com",
  projectId: "check-in-b0aca",
  storageBucket: "check-in-b0aca.appspot.com",
  messagingSenderId: "945182107393",
  appId: "1:945182107393:web:1dc6d035d4dd8356c5dd00"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app, 'check-in-inventory');
export const storage = getStorage(app);

export default app;